import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfileTabBarScrollingProps {
  /** Optional className override for the outer padding wrapper. */
  className?: string;
  /** Optional className override for the inner horizontal scroller. */
  innerClassName?: string;
  children: ReactNode;
}

/**
 * Tab-bar wrapper for entry points whose tab strip can overflow horizontally
 * on narrow screens (arbitrator/review, tasks/task-profile). Applies the
 * canonical outer `"px-4 py-4 md:px-8 md:py-6"` padding PLUS an inner
 * `"w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"`
 * scroller. The inner scroller hides its scrollbar across Firefox / WebKit.
 *
 * For the non-scrolling variant, see {@link ProfileTabBar}.
 */
export function ProfileTabBarScrolling({
  className,
  innerClassName,
  children,
}: ProfileTabBarScrollingProps) {
  return (
    <div className={cn("px-4 py-4 md:px-8 md:py-6", className)}>
      <div
        className={cn(
          "w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
